import { createFileRoute } from '@tanstack/react-router'
import { ThemePreview } from '@/components/ThemePreview'

export const Route = createFileRoute('/_app/theme-preview')({
  component: ThemePreview,
  staticData: {
    title: "Settings",
  }
})
